/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_7c4b25da"]'><div :class='["dialog-alert-demo"]'><cube-button @_click="onClickDialog">Dialog - alert-with-inner-icon</cube-button><cube-dialog ref="__mpx_ref_dialogAlertWithInnerIcon__" type="alert" icon="alert" title="我是标题" content="我是内容" confirmBtn="我知道了"></cube-dialog></div></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_7c4b25da"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_7c4b25da"}
  /** script content **/
  require("./dialog-alert-with-inner-icon.mpx.js?isComponent&outputPath=components%2Fdialog-alert-with-inner-icon7c4b25da%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-alert-with-inner-icon.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-alert-with-inner-icon7c4b25da%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_7c4b25da"],
    ctorType: "component",
    outputPath: "components/dialog-alert-with-inner-icon7c4b25da/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>